import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaktile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 12C0 6.34315 0 3.51472 1.75736 1.75736C3.51472 0 6.34315 0 12 0H12.3409C17.9978 0 20.8262 0 22.5836 1.75736C24.341 3.51472 24.341 6.34315 24.341 12C24.341 17.6569 24.341 20.4853 22.5836 22.2426C20.8262 24 17.9978 24 12.341 24H12C6.34315 24 3.51472 24 1.75736 22.2426C0 20.4853 0 17.6569 0 12Z",
			fill: "#493FC1"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_477_14426)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M14.2893 7L12.1705 9.00585L10.0517 7H6.08527V8.5995H9.26301L11.2785 10.5067V17H13.0767V10.4933L15.078 8.5995H18.2557V7H14.2893Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_477_14426",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 12.1705,
				height: 10,
				fill: "white",
				transform: "translate(6.08527 7)"
			})
		}) })
	]
});
export default SvgTaktile;
